import React, { Component } from 'react';
import './Terms.scss';
import Header from '../../components/Header/header';
import Footer from '../../components/Footer/Footer';
import { Termspage } from '../../global/texts/Terms';
import { Helmet } from 'react-helmet';
import { seoData } from '../../global/seoData';
import { globalVal } from '../../global/globalvalues';

type initialProps = {
    history: any;
};
type initialState = {};

export class Terms extends Component<initialProps, initialState> {
    componentDidMount() {
        window.scroll(0, 0);
    }
    render() {
        return (
            <div className="TermsPageMain">
                 <Helmet>
                    <title>{seoData.terms.title}</title>
                    <meta property="og:site_name" name="site_name" content={globalVal && globalVal.long_name} />
                    <meta property="og:title"  name="title" content={seoData.terms.title} />
                    <meta property="og:description" name="description" content={seoData.terms.description} />
                    <meta name="keywords" content={seoData.terms.keywords} />
                </Helmet>
               
                <Header history={this.props.history} />
                <div className="mediaQueriesTerms">
                    <div className="TermsPageContent">
                        <h1 className="TermsTitle">{Termspage.Terms_title.title}</h1>
                        <div className="TermsLine"></div>
                        <div>
                            {Termspage &&
                                Termspage.TermsContent.length > 0 &&
                                Termspage.TermsContent.map((items: any, index: number) => {
                                    return (
                                        <div key={index}>
                                            <span className="TermsHeadings">
                                                {index + 1}. {items.heading}
                                            </span>
                                            <div
                                                className="TermsPara"
                                                dangerouslySetInnerHTML={{
                                                    __html: items.para,
                                                }}
                                            ></div>
                                        </div>
                                    );
                                })}
                        </div>
                    </div>
                </div>
                <Footer isFixed={true} />
            </div>
        );
    }
}

export default Terms;
